import { render, staticRenderFns } from "./PublicationBody.vue?vue&type=template&id=3f81c3c3&scoped=true&lang=pug"
import script from "./PublicationBody.vue?vue&type=script&lang=js"
export * from "./PublicationBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f81c3c3",
  null
  
)

export default component.exports